<template>
  <div style="padding-bottom:44px">
    <van-field label="序列号" v-model="wdd008_Step2.serialNumber">
      <template #right-icon>
        <van-tag type="warning">{{jieMa}}</van-tag>
      </template>
    </van-field>
    <van-cell title="版本号确认">
      <template #right-icon>
        <van-checkbox v-model="wdd008_Step2.banBenHaoQueRen" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="5V测量">
      <template #right-icon>
        <van-checkbox v-model="wdd008_Step2.wuFuCeLiang" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="屏幕显示">
      <template #right-icon>
        <van-checkbox v-model="wdd008_Step2.pingMuXianShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="按键测试">
      <template #right-icon>
        <van-checkbox v-model="wdd008_Step2.anJianCeShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="时间测试">
      <template #right-icon>
        <van-checkbox v-model="wdd008_Step2.shiJianCeShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="压力传感器测试">
      <template #right-icon>
        <van-checkbox v-model="wdd008_Step2.yaLiChuanGanQiCeShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="位移传感器测试">
      <template #right-icon>
        <van-checkbox v-model="wdd008_Step2.weiYiChuanGanQiCeShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="老化">
      <template #right-icon>
        <van-checkbox v-model="wdd008_Step2.laoHua" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="上升测试">
      <template #right-icon>
        <van-checkbox v-model="wdd008_Step2.shangShengCeShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="下降测试">
      <template #right-icon>
        <van-checkbox v-model="wdd008_Step2.xiaJiangCeShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="打印测试">
      <template #right-icon>
        <van-checkbox v-model="wdd008_Step2.daYinJiCeShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="联网测试">
      <template #right-icon>
        <van-checkbox v-model="wdd008_Step2.lianWangCeShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-field label="备注" v-model="wdd008_Step2.remark"> </van-field>
    <el-button type="primary" class="footer1" icon="el-icon-view" circle @click="handlePicClick"></el-button>
    <div class="footer">
      <van-button type="info" v-show="$parent.hasPower_Step2" round block :disabled="$parent.wdd008_SignNumber.status!=0" @click="handleSave">保存</van-button>
      <van-button type="danger" v-if="$parent.wdd008_SignNumber.status==2" round block @click="$parent.cancel_void_SignNumber()">取消作废</van-button>
      <van-button type="danger" v-else-if="$parent.wdd008_SignNumber.status!=1" round block @click="$parent.void_SignNumber()">作废</van-button>

    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  props: ["signNumber"],
  data() {
    return {
      wdd008_Step2: {},
      jieMa: "",
    };
  },
  methods: {
    handlePicClick() {
      ImagePreview(["./images/WDD008_Produce1.png"]);
    },
    getWDD008_Step2() {
      let that = this;
      that.axios
        .post("/WDD008/GetWDD008_Step2", { onlyText: that.signNumber })
        .then(function (response) {
          that.wdd008_Step2 = response.data.data;
        });
    },
    handleSave() {
      let that = this;
      that.axios
        .all([that.save_WDD008_Step2(), that.registerSerialNumber()])
        .then(
          that.axios.spread(function (response1, response2) {
            that.wdd008_Step2 = response1.data.data;
            if (response1.data.code == 201) {
              that.$notify({ type: "warning", message: response1.data.msg });
            } else if (response2.data.code == 201) {
              that.$notify({ type: "warning", message: response2.data.msg });
            } else {
              that.$notify({ type: "success", message: response1.data.msg });
            }
            if (response2.data.code == 101) {
              that.jieMa = response2.data.msg;
            }
          })
        );
    },
    save_WDD008_Step2() {
      let that = this;
      return that.axios.post("WDD008/UpdateWDD008_Step2", that.wdd008_Step2);
    },
    registerSerialNumber() {
      let that = this;
      return that.axios.post("Base_Device/Register", {
        productName: "一休稳定度",
        productId: 1058,
        serialNumber: that.wdd008_Step2.serialNumber,
        deviceType: "WDD008",
        companyName: "",
        ifPrint: false,
      });
    },
  },
  mounted() {
    let that = this;
    that.getWDD008_Step2();
  },
};
</script>

<style scoped>
.footer {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
}
.footer1 {
  position: fixed;
  left: 10px;
  bottom: 50px;
}
</style>